import React, { useEffect } from "react";
import ColorBlocks from "../ColorBlocks/ColorBlocks";
import { useDispatch, useSelector } from "react-redux";
import { removeSelectedColors, setSelectedColors } from "../../appState/slices/auth/authSlice";
import { getColors } from "../../appState/slices/color/colorSlice";

const ColorDropDown = ({ updateSelectedFilter }) => {
  const availableColors = useSelector((state) => state.product.availableColors);
  const selectedcolors = useSelector((state) => state.auth.category.selectedcolors);
  const dispatch = useDispatch();

  useEffect(() => {
    updateSelectedFilter("color");
  }, []);

  const selectColor = (color) => {
    if (selectedcolors.includes(color)) {
      dispatch(removeSelectedColors(color));
    } else {
      dispatch(setSelectedColors(color));
    }
  };

  return (
    <div>
      <div className="colordropdown">
        {Object.values(availableColors).map((color) => (
          <div
            key={color}
            onClick={() => selectColor(color)}
            className={`${selectedcolors.includes(color) ? "productcolorselected" : ""}`}
          >
            <ColorBlocks
              withname={true}
              selected={selectedcolors.includes(color)}
              name={color}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorDropDown;
